import { useCallback, useMemo, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import swal from 'sweetalert'

import { CatchError } from 'Exceptions/exceptions'
import UserService from 'Main/service/UserService'
import CommonListApiPaginated from 'views/components/Table/CommonListApiPaginated'
import { getRefreshToken } from 'variables/common'

function UserSession () {
  const navigate = useNavigate()
  const refreshToken = getRefreshToken()
  const userService = useMemo(() => new UserService(), [])
  const [reloadKey, setReloadKey] = useState(0)
  const [copiedId, setCopiedId] = useState(null)

  const getSessions = useCallback(() => userService.getSessions(), [userService])

  const handleListError = useCallback((error) => {
    CatchError(error, navigate, refreshToken)
  }, [navigate, refreshToken])

  const handleCopy = useCallback((id, token) => {
    navigator.clipboard.writeText(token).then(() => {
      setCopiedId(id)
      window.setTimeout(() => setCopiedId((current) => current === id ? null : current), 1500)
    })
  }, [])

  const handleAdd = () => {
    const content = document.createElement('div')
    content.innerHTML = `
      <div class="form-group text-start mb-2">
        <label class="form-label">Host Name</label>
        <input id="us_name" type="text" class="form-control" placeholder="Insert Host Name" />
      </div>
    `

    swal({
      title: 'Add New User Session',
      content,
      buttons: { cancel: 'Cancel', confirm: { text: 'Add User Session', closeModal: false } }
    }).then(async (confirmed) => {
      if (!confirmed) return

      const deviceName = content.querySelector('#us_name').value

      try {
        await userService.createSession(deviceName)
        swal.close()
        await swal('Success!', 'Success Add User Session', 'success')
        setReloadKey((current) => current + 1)
      } catch (error) {
        const caught = CatchError(error, navigate, refreshToken)
        if (caught !== undefined) swal('Error', 'Failed to add user session', 'error')
      }
    })
  }

  const handleDelete = useCallback((id) => {
    swal('Delete API Session', 'Are You Sure Delete User Session?', 'warning', {
      buttons: { cancel: 'Cancel', delete: { text: 'Delete', value: 'delete' } },
      dangerMode: true
    }).then(async (value) => {
      if (value !== 'delete') return

      try {
        await userService.deleteSession(id)
        await swal('Success!', 'User session deleted', 'success')
        setReloadKey((current) => current + 1)
      } catch (error) {
        const caught = CatchError(error, navigate, refreshToken)
        if (caught !== undefined) swal('Error', 'Failed to delete user session', 'error')
      }
    })
  }, [navigate, refreshToken, userService])

  const columns = useMemo(() => [
    { header: 'Perangkat', accessorKey: 'device_name', minWidth: 700, },
    { header: 'Terakhir Login', accessorKey: 'date', minWidth: 100, },
    {
      header: 'API Key',
      accessorKey: 'token',
      enableSorting: false,
      filterable: false,
      exportable: false,
      maxWidth: 150,
      cell: ({ row }) => (
        <button type="button" onClick={() => handleCopy(row.original.id, row.original.token)} className="btn btn-success" title="Copy Token">
          <i className={`fa-solid ${copiedId === row.original.id ? 'fa-check' : 'fa-clipboard'}`} />
          &nbsp;&nbsp;{copiedId === row.original.id ? 'Copied' : 'Copy Token'}
        </button>
      )
    },
    {
      header: 'Hapus',
      id: 'actions',
      enableSorting: false,
      filterable: false,
      exportable: false,
      maxWidth: 80,
      cell: ({ row }) => (
        <button type="button" onClick={() => handleDelete(row.original.id)} className="btn btn-danger" title="Delete Session">
          <i className="fa-solid fa-trash-can" />
        </button>
      )
    }
  ], [copiedId, handleCopy, handleDelete])

  const menu = (
    <div className="text-center">
      <button type="button" onClick={handleAdd} className="btn btn-success" title="Add Session">
        <i className="fa-solid fa-pen-to-square" />&nbsp;&nbsp; Tambah Session Baru
      </button>
    </div>
  )

  return (
    <div className="page-content">
      <section>
        <CommonListApiPaginated
          header="List User Session"
          columns={columns}
          getData={getSessions}
          menu={menu}
          reloadKey={reloadKey}
          loadingLabel="Loading user sessions..."
          emptyLabel="No sessions found"
          onError={handleListError}
        />
      </section>
    </div>
  )
}

export default UserSession
